/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

import React, { useState, useEffect } from "react";
import { Nav, Navbar } from "react-bootstrap";
import Classes from "./index.css";
import { isMobileOrTablet } from "../Utils";
import axios from "axios";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu";
import RigVedQuotes from "../RigvedQuotes";

const HeaderNavbar = () => {
  const [navbar, setNavbar] = useState(false);
  const [showRigVedQuotes, setShowRigVedQuotes] = useState(false);
  const isMobileOrTabletDevice = isMobileOrTablet();
  const [quotes, setQuotesData] = useState([]);
  let prevScrollPos = window.scrollY;

  window.onscroll = function () {
    const currentScrollPos = window.scrollY;
    const menuNavbar = document.getElementById("menuNavbar");

    if (currentScrollPos === 0) {
      menuNavbar.classList.remove("navbarTransition");
      setNavbar(false);
    } else {
      if (prevScrollPos > currentScrollPos) {
        // Perform your desired actions for scrolling up here
        setNavbar(true);
      } else if (prevScrollPos < currentScrollPos) {
        // Perform your desired actions for scrolling down here
        if (!isMobileOrTabletDevice) {
          setNavbar(true);
        } else {
          setNavbar(false);
          menuNavbar.classList.add("navbarTransition");
          setShowRigVedQuotes(false);
        }
      }
    }
    prevScrollPos = currentScrollPos;
  };
  useEffect(() => {
    const fetchQuotesJSON = async () => {
      try {
        const timestamp = Date.now();
        const url = `${process.env.REACT_APP_QUOTES_JSON}?timestamp=${timestamp}`;
        const response = await axios.get(url);
        const quotesArray = response.data.quotes;
        setQuotesData(quotesArray);
      } catch (error) {
        console.log("Unable to load quotes: ", error);
      }
    };
    fetchQuotesJSON();
  }, []);

  return (
    <>
      <div>
        <Navbar
          id="menuNavbar"
          collapseOnSelect
          expand="lg"
          fixed="top"
          bg="dark"
          variant="dark"
          className={navbar ? "navbar active" : "navbar"}
        >
          <Navbar.Brand className="ps-3">
            <div className="d-flex">
              <div>
                <a
                  href="https://www.swmc.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Sun West Mortgage Logo"
                >
                  <img
                    src={
                      "https://resources.swmc.com/swmc-images/sunwest-trust-white-logo.png"
                    }
                    className="main_logo img-fluid"
                    alt="Sun West Logo"
                  />
                </a>
              </div>
            </div>
          </Navbar.Brand>

          <div className="angelai-logo-wrapper">
            <div className="angelai-logo-container">
              <Nav className={Classes.nav_temp}>
                <a
                  href="https://www.angelai.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={
                      "https://d2b7dijo04ypct.cloudfront.net/carolinasConnect/postevent/angelai-logo.webp"
                    }
                    className="angelai-university"
                    alt="AngelAi Logo"
                  ></img>
                </a>
                <div className="userway-div-desktop"></div>
              </Nav>

              <div className="brandTagLineContainerDesktop">
                <p
                  variant="primary"
                  className="brandTagLine"
                  onClick={() => {
                    setShowRigVedQuotes(true);
                  }}
                  onMouseOver={() => {
                    setShowRigVedQuotes(true);
                  }}
                  onMouseOut={() => {
                    setShowRigVedQuotes(false);
                  }}
                  aria-label="Brand Tag Line"
                >
                  Nothing Is Beyond Reach<sup>&reg;</sup>
                </p>
                <RigVedQuotes showRigVedQuotes={showRigVedQuotes} />
              </div>
            </div>
            <UserWayAccessibilityMenu color="white" width={40} height={40} />
          </div>
        </Navbar>
      </div>
    </>
  );
};

export default HeaderNavbar;
